import { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { useAuth } from '../contexts/AuthContext'
import Avatar from './Avatar'

function UserInfo({ showLogout = true }) {
  const navigate = useNavigate()
  const { user, logout } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)
  const menuRef = useRef(null)

  const handleLogout = async () => {
    try {
      setMenuOpen(false)
      await logout()
      navigate('/login')
    } catch (error) {
      console.error('Logout error:', error)
      Sentry.captureException(error)
    }
  }

  useEffect(() => {
    if (!menuOpen) return
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [menuOpen])

  return (
    <div className="user-info" ref={menuRef}>
      <Avatar photoURL={user?.photoURL} displayName={user?.displayName || user?.email} />
      {showLogout && (
        <>
          <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <rect x="3" y="5" width="18" height="2" rx="1" />
              <rect x="3" y="11" width="18" height="2" rx="1" />
              <rect x="3" y="17" width="18" height="2" rx="1" />
            </svg>
          </button>
          {menuOpen && (
            <div className="user-menu">
              <button onClick={handleLogout}>Sign Out</button>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default UserInfo
